import { createReducer } from '@reduxjs/toolkit'
import types from './types'

export { default as actions } from './actions'

export default createReducer(
  {},
  {
    [types.UPDATE_FILTERS_SUCCESS]: (state, action) => {
      state.record = action.payload
    },
  },
)
